import { apiUrl } from "../../common/api/config";

export const getFinancials = async (periodRange = {}) => {
  const token = localStorage.getItem("accessToken");
  const params = new URLSearchParams();

  if (periodRange.period_start) {
    params.append("period_start", periodRange.period_start);
  }
  if (periodRange.period_end) {
    params.append("period_end", periodRange.period_end);
  }

  const queryString = params.toString();
  const url = `${apiUrl}/analytics/financials/${queryString ? "?" + queryString : ""}`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  });

  const data = await response.json();
  if (response.ok) return data;
  throw new Error(data.detail || "Failed to fetch financials");
};

export const getProducerDetail = async (userId, periodRange = {}) => {
  const token = localStorage.getItem("accessToken");
  const params = new URLSearchParams();

  if (periodRange.period_start) {
    params.append("period_start", periodRange.period_start);
  }
  if (periodRange.period_end) {
    params.append("period_end", periodRange.period_end);
  }

  const queryString = params.toString();
  const url = `${apiUrl}/analytics/producer-detail/${userId}/${queryString ? "?" + queryString : ""}`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  });

  const data = await response.json();
  if (response.ok) return data;
  throw new Error(data.detail || "Failed to fetch producer detail");
};

export const getWaterfall = async (periodRange = {}, assetId = null) => {
  const token = localStorage.getItem("accessToken");
  const params = new URLSearchParams();

  if (periodRange.period_start) {
    params.append("period_start", periodRange.period_start);
  }
  if (periodRange.period_end) {
    params.append("period_end", periodRange.period_end);
  }

  const queryString = params.toString();
  const path = assetId
    ? `/analytics/waterfall/${assetId}/`
    : "/analytics/waterfall/";
  const url = `${apiUrl}${path}${queryString ? "?" + queryString : ""}`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  });

  const data = await response.json();
  if (response.ok) return data;
  throw new Error(data.detail || "Failed to fetch waterfall");
};
